import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { store } from "@/store";
import { useTheme } from "@/hooks/useTheme";
import AppLayout from "@/components/layout/AppLayout";
import AddressesPage from "@/pages/AddressesPage";
import PrintPage from "@/pages/PrintPage";

export function AppContent(): JSX.Element {
  const { themeMode } = useTheme();
  const theme = createTheme({
    palette: {
      mode: themeMode === "auto" ? "light" : themeMode,
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AppLayout>
          <Routes>
            <Route path="/" element={<Navigate to="/addresses" replace />} />
            <Route path="/addresses" element={<AddressesPage />} />
            <Route path="/print" element={<PrintPage />} />
          </Routes>
        </AppLayout>
      </BrowserRouter>
    </ThemeProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <AppContent />
    </Provider>
  </React.StrictMode>
);
